import { render, staticRenderFns } from "./IOSGuide.vue?vue&type=template&id=5e921103&scoped=true&"
import script from "./IOSGuide.vue?vue&type=script&lang=js&"
export * from "./IOSGuide.vue?vue&type=script&lang=js&"
import style0 from "./IOSGuide.vue?vue&type=style&index=0&id=5e921103&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e921103",
  null
  
)

export default component.exports